import SingleKeyIcon from './SingleKeyIcon'

export default SingleKeyIcon
